import React from 'react'
import { Button, Form, FormGroup, Input, InputGroup, Label, Nav, NavItem, NavLink, InputGroupAddon } from 'reactstrap'
import tapOrClick from 'react-tap-or-click'
import Loader from 'react-loader-spinner'
import ReactAutoSuggestDropdown from '../../ui/AutoSuggestionDropdown'
import ExtendIcon from 'react-icons/lib/fa/expand'
import EditPlanIcon from 'react-icons/lib/fa/edit'
import AddPlanIcon from 'react-icons/lib/fa/plus-square'
import SubsListIcon from 'react-icons/lib/fa/list'
import { subscriptionHelpers } from '../../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY, authRedirect, } from '../../../dataHelpers/authenticationHelpers'
import classnames from 'classnames'
import '../../../stylesheets/ControllerDashboard.css'
import AppError from "../../../models/AppError"
import { getController } from "../../../api"
import { ErrorModal } from '../../ui'
import {
    NO_CONTROLLER_SELECT, ENTER_CONTROLLER_PHONE, NO_VALUE, ENTER_EXTEND_VAL, ENTER_VALID_EXTEND_VAL,
    SUCCESS, EXTEND_VAL_UPDATE
} from '../../../constants'

class ExtendSubscription extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            activeTab: '3',
            errors: [],
            currentControllerPage: 1,
            controllers: [],
            extendDayVal: '',
            selectControllerID: null,
            loading: false,
            chosenValue: '',
            searchValue: '',
            showDropdown: false,
            isTrial: false,
            remainingDayVal: '',
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.onChange = this.onChange.bind(this)
        this.submitForm = this.submitForm.bind(this)
        this.chooseDropdownItem = this.chooseDropdownItem.bind(this)
        this.updateSearchValue = this.updateSearchValue.bind(this)
        this.showDropdown = this.showDropdown.bind(this)
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    componentDidMount() {
        this.fetchControllers()
    }

    onChange(e) {
        this.setState({ extendDayVal: e.target.value })
    }

    async fetchControllers() {
        try {
            this.setState({ loading: true })              
            let results = await subscriptionHelpers.getSubscriptionControllers(this.token)
            this.setState({ controllers: results })
        } catch (error) {
            console.log(error)
        }
        this.setState({ loading: false })
    }

    async chooseDropdownItem(e, valueSelected, valueObject) {
        e.preventDefault()
        let remainingDays = 0
        let selectId = this.state.controllers.filter(function (e) { return e.serial_number === valueSelected; })
        let controller = await getController(this.token, selectId[0].controller)
        console.log("Controller what:")
        console.log(controller)
        console.log('remD',controller.freeDaysRemaining)
        if (!controller.error) {
            remainingDays = controller.freeDaysRemaining
        }
        this.setState({
            showDropdown: false,
            searchValue: valueSelected,
            selectControllerID: selectId[0].id,
            isTrial: selectId[0].is_trial,
            extendDayVal: selectId[0].extended_days,
            remainingDayVal: selectId[0].remaining_days
        })
    }

    updateSearchValue(e) {
        e.preventDefault()
        if (e.target.value) {
            this.setState({ searchValue: e.target.value })
        } else {
            this.setState({
                searchValue: e.target.value,
                selectControllerID: '',
                isTrial: false,
            })
        }
    }

    showDropdown() {
        this.setState({ showDropdown: true })
    }

    async submitForm(e) {
        e.preventDefault()
        this.setState({ loading: true })
        let { extendDayVal, selectControllerID } = this.state
        if (selectControllerID) {
            selectControllerID = selectControllerID.toString()
        }
        if (!selectControllerID || !selectControllerID.length) {
            let appError = new AppError(NO_CONTROLLER_SELECT, ENTER_CONTROLLER_PHONE)
            await this.setState({ errors: [appError], loading: false })
            return
        }
        extendDayVal = extendDayVal.toString()
        if (!extendDayVal || !extendDayVal.length) {
            let appError = new AppError(NO_VALUE, ENTER_EXTEND_VAL)
            await this.setState({ errors: [appError], loading: false })
            return
        }

        if (!extendDayVal.match(/^\d+(\.\d+)?$/)) {
            let appError = new AppError(NO_VALUE, ENTER_VALID_EXTEND_VAL)
            await this.setState({ errors: [appError], loading: false })
            return
        }

        let extendresponse = await subscriptionHelpers.extendSubsDays(this.token, selectControllerID, extendDayVal)
        if (!extendresponse.error) {
            let appError = new AppError(SUCCESS, EXTEND_VAL_UPDATE)
            await this.setState({ errors: [appError], loading: false, extendDayVal: '', searchValue: '', isTrial: false })
            return
        } else {
            this.setState({ errors: [extendresponse.error] })
        }
    }

    render() {
        let { loading, controllers, extendDayVal, errors, isTrial, remainingDayVal } = this.state
        return (<div>
            <div className="m-0 p-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionsetting`, this.props.history)) })}
                        >
                            <AddPlanIcon />&ensp;Create Plan
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptioninitialplan`, this.props.history)) })}
                        >
                            <EditPlanIcon />&ensp;Edit Plan
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionsetting/extendsubscription`, this.props.history)) })}
                        >
                            <ExtendIcon />&ensp;Extend Plan
                            </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '4' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionplanlist`, this.props.history)) })}>
                            <SubsListIcon />&ensp;Available Plans
                            </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <div className="row justify-content-center align-items-center bg-light large-rounded border-light-sf-orange p-0 pb-4">
                <h1 className="text-center mb-4 form-head col-12">Extend Plan for Controller</h1>
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <Form onSubmit={this.submitForm} className="col-lg-6 col-md-8 col-sm-10">
                        <FormGroup>
                            <div className="text-left">
                                <Label>Controller</Label>
                            </div>
                            <InputGroup>
                                <ReactAutoSuggestDropdown
                                    list={controllers}
                                    showDropdown={this.showDropdown}
                                    displayDropdownMenu={this.state.showDropdown}
                                    chosenValue={this.state.chosenValue}
                                    chooseDropdownItem={this.chooseDropdownItem}
                                    updateSearchValue={this.updateSearchValue}
                                    searchValue={this.state.searchValue}
                                    highlightColour={"#ff9966"}
                                    placeholder="Serial Number"
                                />
                            </InputGroup>
                            {isTrial ? <div><br />
                                <div className="text-left">
                                    <Label>Remaining Days</Label>
                                </div>
                                <InputGroup>
                                    <Input type="remainingvalue"
                                        placeholder={``}
                                        value={remainingDayVal}
                                        maxLength={3}
                                        readOnly
                                    />
                                </InputGroup></div> : ''}
                            <br />
                            <div className="text-left">
                                <Label>Extend Plan By</Label>
                            </div>
                            <InputGroup>
                                <Input type="extendvalue"
                                    placeholder={`0`}
                                    value={extendDayVal}
                                    //onChange={this.onChange} 
                                    onChange={(evt) => this.setState({ extendDayVal: evt.target.value })}
                                    maxLength={3}
                                />
                                <InputGroupAddon addonType="append">days</InputGroupAddon>
                            </InputGroup>
                        </FormGroup>
                        <Button className="mt-3">Extend Plan</Button>
                    </Form>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
            </div>
        </div>)
    }
}
export default ExtendSubscription



// WEBPACK FOOTER //
// ./src/components/pages/subscription/ExtendSubscription.js